import React from 'react';
import { Card, Icon, Modal } from 'antd';
import styled from 'styled-components/macro';

import { URL_FB_PAGE, URL_HAS_LEGAL_TERMS_PAGE } from 'utils/urls';
import Description from 'components/Description/Description';
import Heading from 'components/Heading/Heading';

const FbPageDisplayContainer = styled.div`
  width: 200px;
  margin: 0 auto;
  text-align: center;

  @media (min-width: 360px) {
    width: 250px;
  }

  @media (min-width: 425px) {
    width: 300px;
  }

  @media (min-width: 768px) {
    width: 420px;
  }
`;

const TNCCheckedIcon = styled(Icon)`
  color: #00b7ce;
`;

const CampaignSignUpModal = ({ visible, onOk, onModalClose }) => {
  return (
    <Modal visible={visible} onOk={onOk} onCancel={onModalClose} okText="Agree & Continue" forceRender>
      <Card>
        <Heading size="small">Hi there!</Heading>
        <Description>
          One last step to make your vote count! Be sure to <b>"Like"</b> our page for updates on the contest. You could be the next winner!
        </Description>
        <FbPageDisplayContainer>
          <div className="fb-page" data-href={URL_FB_PAGE} data-hide-cover="false" data-show-facepile="true" data-adapt-container-width="true" />
        </FbPageDisplayContainer>
        <br />
        <Description size="small">
          <TNCCheckedIcon type="check-circle" theme="filled" /> By clicking{' '}
          <b>
            <i>Agree & Continue</i>
          </b>
          , you agree to our{' '}
          <a href={URL_HAS_LEGAL_TERMS_PAGE} target="_blank" rel="noopener noreferrer">
            Terms and Policy
          </a>
          .
        </Description>
      </Card>
    </Modal>
  );
};

export default CampaignSignUpModal;